 
  <div class="container padding-bottom-55">
	
		<ul class="menu-horizontal-sura">
			<li *ngFor="let element of links"><a href="{{element.path}}">{{element.link}}</a></li>
		</ul>
		
	    <span class="info-user">
           <span class="color-regular-sura">{{obtenerNombre()}}</span>
           
           <button mat-button [matMenuTriggerFor]="opcionesNavs" class="pl-0 pr-0 width-button-gen">
                <mat-icon >more_vert</mat-icon>
           </button>
           <mat-menu #opcionesNavs="matMenu">
               <a mat-menu-item [routerLink]="['/cambiarContrasenia']"  [queryParams]="{ returnUrl: this.linkActive }" class="link-sura">Cambiar Contrase&ntilde;a</a>
               <a mat-menu-item [routerLink]="['/ingreso']" class="link-sura">Cerrar Sesi&oacute;n</a>
           </mat-menu>

           
	       
	    </span>
	
  </div>
 
<div class="background-nav-mobil  d-sm-block d-md-none ">
    <div class="d-flex">
        <div class="mr-auto">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>menu</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <a *ngFor="let element of links" mat-menu-item href="{{element.path}}">
                    <mat-icon>arrow_right</mat-icon>
                    <span>{{element.link}}</span>
                </a>
            </mat-menu>
        </div>
        <div class="d-flex">
 
			  <span class="info-user v-movil">
			       <span class="color-regular-sura">{{obtenerNombre()}}</span> | 
			      <a [routerLink]="['/login']" class="link-primary">Cerrar Sesión</a>
			    </span>

        </div>
    </div>
</div>
